import type { LineTab } from '~/components/molecule/LineTabs';
import {
  GetLfaConversionsTotalsQuery,
  GetLfaConversionFilterType,
} from '~/graphql/types';

const text = {
  today: 'Vandaag',
  later: 'Na vandaag',
  done: 'Afgerond',
  all: 'Alles',
};

const getConversionTabs = (
  totals: GetLfaConversionsTotalsQuery,
): Array<LineTab> => [
  {
    key: GetLfaConversionFilterType.Today,
    label: text.today,
    dataTestId: GetLfaConversionFilterType.Today,
    accentedLabel: `${totals.today.total}`,
  },
  {
    key: GetLfaConversionFilterType.Later,
    label: text.later,
    dataTestId: GetLfaConversionFilterType.Later,
    accentedLabel: `${totals.later.total}`,
  },
  {
    key: GetLfaConversionFilterType.Done,
    label: text.done,
    dataTestId: GetLfaConversionFilterType.Done,
    accentedLabel: `${totals.done.total}`,
  },
  {
    key: GetLfaConversionFilterType.All,
    label: text.all,
    dataTestId: GetLfaConversionFilterType.All,
    accentedLabel: `${totals.all.total}`,
  },
];

export default getConversionTabs;
